// Navigation.js
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@iconify/react';

// ----------------------------
// CONFIGURATION
// ----------------------------

const NAV_ITEMS = [
  {
    id: 'home',
    name: 'Home',
    icon: 'ri:home-2-line',
    activeColor: '#000000',
    inactiveColor: '#9E9E9E'
  },
  {
    id: 'friends',
    name: 'Friends',
    icon: 'ant-design:user-add-outlined',
    activeColor: '#000000',
    inactiveColor: '#9E9E9E'
  },
  {
    id: 'wallet',
    name: 'Wallet',
    icon: 'ion:wallet-outline',
    activeColor: '#000000',
    inactiveColor: '#9E9E9E'
  }
];

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  background-color: white;
  border-top: 1px solid #eaeaea;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0 -1px 5px rgba(0,0,0,0.05);
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const NavItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 55px;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(0.95);
  }
  
  &:active {
    transform: scale(0.9);
  }
  
  svg {
    width: 24px;
    height: 24px;
    transition: color 0.2s ease;
  }
`;

const NavText = styled.div`
  font-size: 12px;
  margin-top: 4px;
  color: ${props => props.$active ? 'black' : '#9E9E9E'};
  font-weight: ${props => props.$active ? 'bold' : 'normal'};
`;

const Navigation = React.memo(({ activePage, onNavigate }) => {
  return (
    <NavContainer>
      {NAV_ITEMS.map((item) => {
        const isActive = activePage === item.id;
        
        return (
          <NavItem 
            key={item.id}
            $active={isActive} 
            onClick={() => onNavigate(item.id)}
          >
            <div className={`nav-icon ${isActive ? 'nav-active' : 'nav-inactive'} interactive-icon icon-container`}>
              <Icon 
                icon={item.icon}
                color={isActive ? item.activeColor : item.inactiveColor}
                width="24px"
                height="24px"
              />
            </div>
            <NavText $active={isActive}>{item.name}</NavText>
          </NavItem>
        );
      })}
    </NavContainer>
  );
});

export default Navigation;
